import React from "react"
import OperationsPage from "../modules/Operations/OperationsPage"

export function OperationsTab() {
	return <OperationsPage />
}
